import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { retry, catchError, tap } from 'rxjs/operators';
import { SharedService } from '../services/shared.service';
import { IDisbursementOccurrence } from '../interfaces/disbursement-occurrence';
// import { IPaymentResponse } from '../interfaces/payment-response';

@Injectable({
  providedIn: 'root'
})
export class DisbursementOccurrenceService {

  private disbursementOccurrencesUrl = '/client/occurrences';
  private disbursementOccurrenceUrl = '/client/occurrences/{dsbOccrId}';
  private disburseFundsUrl = '/client/payments/{billerId}';

  constructor(
    private http: HttpClient,
    private sharedService: SharedService
  ) { }

  public fetchDisbursementOccurrences(envRegion: string, sessionId: string): Observable<IDisbursementOccurrence[]> {
    let url = this.sharedService.getDisbursementsBaseUrl(envRegion) + this.disbursementOccurrencesUrl;
    let headers = new HttpHeaders()
      .set('session-id', sessionId);
    return this.http.get<IDisbursementOccurrence[]>(url, { headers: headers, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  public fetchDisbursementOccurrence(envRegion: string, sessionId: string, dsbOccrId: number):
       Observable<IDisbursementOccurrence> {
    let url = this.sharedService.getDisbursementsBaseUrl(envRegion)
       + this.disbursementOccurrenceUrl.replace('{dsbOccrId}', dsbOccrId.toString());
    let headers = new HttpHeaders()
      .set('session-id', sessionId);
    return this.http.get<IDisbursementOccurrence>(url, { headers: headers, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  public markDisbursementOccurrencesAsViewed(envRegion: string, sessionId: string): Observable<any> {
    let headers = new HttpHeaders()
      .set('session-id', sessionId);
    let url = this.sharedService.getDisbursementsBaseUrl(envRegion) + this.disbursementOccurrencesUrl;
    let request = {
      // "fundingAccountToken": fundingAccountToken,
      // "disbursementOccurrenceUuid": disbursementOccurrenceUuid
    };
    return this.http.put<any>(url, request, { headers: headers, responseType: 'json' })
      .pipe(
        catchError(this.sharedService.handleError)
      )
  }

}
